import jwt_decode from 'jwt-decode';
export function getUserScopes(atoken) {
  /**
   * Return user scopes of given auth0 context
   */
  var payload = atoken && jwt_decode(atoken);
  return payload.scope ? payload.scope : [];
}